import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loading } from '../common';

const ProtectedRoute = ({ children, requireAdmin = false, requireSuperuser = false, allowDepartmentManager = false }) => {
  const { isAuthenticated, isAdmin, isSuperuser, isDepartmentManager, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loading fullScreen text="加载中..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireSuperuser && !isSuperuser) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireAdmin && !(isAdmin || (allowDepartmentManager && isDepartmentManager))) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;

